import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { ExtendSharingContainerComponent } from './extend-sharing-container/extend-sharing-container.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

const ExtendSharingState: Ng2StateDeclaration = {
    name: FiStateNames.ExtendSharing._name,
    url: '/ExtendSharing',
    abstract: true,
    component: FiAbstractStateComponent,
};

const ExtendSharingEditState: Ng2StateDeclaration = {
    name: FiStateNames.ExtendSharing.Edit,
    url: '/{objectId:[0-9]+}/{objectType:[0-9]+}',
    reloadOnSearch: false,
    views: {
        '@Module': {
            component: ExtendSharingContainerComponent,
        },
    },
    resolve: {
        objectId: [FiStateService, Transition, extendSharingEditState_objectId],
        objectType: [FiStateService, Transition, extendSharingEditState_objectType],
    },
};

export const ExtendSharingStates: StatesModule = {
    states: [ExtendSharingState, ExtendSharingEditState],
};

export function extendSharingEditState_objectId(stateService: FiStateService, transition: Transition) {
    return coerceNumberProperty(stateService.getParams(transition).objectId);
}

export function extendSharingEditState_objectType(stateService: FiStateService, transition: Transition) {
    return coerceNumberProperty(stateService.getParams(transition).objectType);
}
